import React, { useState, useMemo, useContext, useEffect } from "react";
import { trackEvent } from '../utils/gtmTracker';
import { GlobalContext } from "../globalContext";
import Pin from "../assets/icons/svg/map-pin-line.svg";
import ArrowDown from "../assets/icons/svg/arrow-down.svg";
import { ordinamentiCard } from '../utils/ordinamentiCard';

export default function OffersGrid({ techFilter , variant = "coveredFtth", segment= "", onChangeSegment, speedFilter="", onChangeSpeedFilter, showStatus = true, showDisclaimer = true, hideOffersCount = false }) {

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedCardId, setExpandedCardId] = useState(null);
  const { store, updateStore, t, resetStore } = useContext(GlobalContext);
  const offers = store.listOfOffers || [];

  const pageSize = 12;

  const variantsInfo = {
    coveredFtth: {
      titleStatus: t.covered,
    },

    //fiberstream da capire se la label è corretta e se le intercetta entrambe fttc e ftth sotto
    coveredFiberstream: {
      titleStatus: t.covered,
    },
    
    fttc_arrivingFtth: {
      titleStatus: t.arriving
    },

    fttc_notArrivingFtth: {
      titleStatus: ""
    },


  };

  const { titleStatus } = variantsInfo[variant] || {};

  function parsePriceNumber(value) {
    if (value == null) return null;

    const normalized = String(value)
      .trim()
      .replace(/€/g, "")
      .replace(/\s/g, "")
      .replace(/\.(?=\d{3}(?:\D|$))/g, "")
      .replace(",", ".");

    if (!normalized || isNaN(normalized)) return null;

    const parsed = parseFloat(normalized);
    if (Number.isNaN(parsed)) return null;

    return Math.round(parsed * 100) / 100;
  }
  
  
  
  // Tracking apertura descrizione card
  function handleToggleDescription(index, olo, pagina, uniqueId, segmentoClientela, prezzo) {
    const isOpening = expandedCardId !== uniqueId;
    trackEvent("offer_card_description_toggle", {
      cardPosition: index + 1,
      operatore: olo,
      paginaOfferte: pagina,
      actionDescriptionToggle: isOpening ? "open" : "close",
      segmentoClientela: segmentoClientela,
      prezzoCard: parsePriceNumber(prezzo)
    });
    setExpandedCardId((prevId) => prevId === uniqueId ? null : uniqueId);
  }


  function handleOpenLink(o, gridIndex) {
    trackEvent("offer_card_click", {
      cardPosition: gridIndex + 1, // posizione 1-based
      operatore: o.operatore,
      paginaOfferte: currentPage,
      nomeOfferta: o.nomeOfferta,
      acronymOlo: o.acronymOlo,
      segmentoClientela: o.segmentoClientela,
      prezzoCard: parsePriceNumber(o.prezzo)
    });
    
      if (o?.linkOAO) {
      window.open(o.linkOAO, "_blank", "noopener"); //,noreferrer");
    }
  }

  const priorityOrder = useMemo(() => {
    const keys = Object.keys(ordinamentiCard).filter(k => Array.isArray(ordinamentiCard[k]));
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    const order = ordinamentiCard[randomKey];
    return order;
  }, []);

  const filtered = useMemo(() => {
    let filteredOffers = offers
      .filter((o) => o.tipoOfferta === techFilter)
      .filter((o) => !segment || o.segmentoClientela === (segment === "privati" ? "C" : "B"))
      .filter((o) =>
        o.operatore.toLowerCase().includes(search.trim().toLowerCase())
      );
    
    if (speedFilter && speedFilter !== "Non Attivo") {
      filteredOffers = filteredOffers.filter((o) => o.velocita === speedFilter);
    }

    const priorityOffers = [];
    const otherOffers = [];

    filteredOffers.forEach(offer => {
      if (priorityOrder.includes(offer.acronymOlo)) {
        priorityOffers.push(offer);
      } else {
        otherOffers.push(offer);
      }
    });

    priorityOffers.sort((a, b) => {
      const indexA = priorityOrder.indexOf(a.acronymOlo);
      const indexB = priorityOrder.indexOf(b.acronymOlo);
      return indexA - indexB;
    });

    return [...priorityOffers, ...otherOffers];
  }, [offers, techFilter, segment, search, speedFilter]);

  
 const totalFilteredOffers = filtered.length;
  const paginated = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, currentPage]);

  function handlePagination(page) {
    trackEvent("pagination_click", {
      paginaOfferte: page
    });
    setCurrentPage(page);
  }

  const totalPages = Math.ceil(filtered.length / pageSize);
  
  
  useEffect(() => {
    setCurrentPage(1);
  }, [segment, techFilter, speedFilter]);


 
  function handleAnotherRequestClick() {
    if (store.selectedAddress) {
      trackEvent("another_request_click", { indirizzo: store.selectedAddress });
    } else {
      trackEvent("another_request_click");
    }
    resetStore();
  }

  function handleNotifyMeModalOpen() {
    trackEvent("notifyme_modal_open", {
      indirizzo: store.selectedAddress || ""
    });
    updateStore({ notifyModalOpen: true });
  }



  return (
     <div className="offers-grid-wrapper">

      <div className="offers-header">
        
        <div className="offers-header__left">

          {showStatus && (
            <p className={`result-status ${variant}`}>
              <span>{titleStatus}</span>
            </p>
          )}

          {store.selectedAddress && (
            <div className="selected-address-row">
              <img src={Pin} alt="" className="selected-address-icon" />
              <span className="selected-address-text">{store.selectedAddress}</span>
            </div>
          )}
          
          <p className="offert-info">
            {!hideOffersCount && `${totalFilteredOffers} `}{t.offersAvailable}{" "}
          </p>

        </div>

        {/* CENTRO: CTA (solo in fttc_arrivingFtth) */}
        <div className="offers-header__center">
          {store.responseStatus === "fttc_arrivingFtth" && (
            <button
              className="back-button"
              onClick={handleNotifyMeModalOpen}
            >
              <p>{t.buttonNotifyMe}</p>
            </button>
          )}
        </div>
        
        {/* DESTRA: vuoto come “spacer” (o futuri controlli) */}
        <div className="offers-header__right" />
        
         {/* MOBILE: azioni + filtro */}
        <div className="offers-header__mobile-actions rp-mobile-only">
          {store.responseStatus !== "fttc_arrivingFtth" && (
             <button
               className="back-button"
               onClick={handleAnotherRequestClick}
             >
               <p>{t.anotherRequest}</p>
             </button>
          )}

          <div className="select-wrapper">
            <img src={ArrowDown} alt="" className="arrow-icon" />
            <select
              value={segment || "privati"}
              onChange={(e) => onChangeSegment?.(e.target.value)}
              className="select-input"
            >
              <option value="privati">{t.filterPrivate}</option>
              <option value="pmi">{t.filters}</option>
            </select>
          </div>
          
         {store.responseStatus === "coveredFtth" && (
            <div className="select-wrapper" style={{ marginTop: 8 }}>
              <img src={ArrowDown} alt="" className="arrow-icon" />
              <select
                value={speedFilter}
                onChange={e => onChangeSpeedFilter?.(e.target.value)}
                className="select-input"
              >
                <option value="Non Attivo">{t.filterVelocity}</option>
                <option value="1G">1G</option>
                <option value="2,5G">2,5G</option>
                <option value="5G">5G</option>
                <option value="10G">10G</option>
                </select>
            </div>
          )}
        </div>

      </div>

      {/* GRIGLIA OFFERTE */}
      <div className="offers-grid">
        {paginated.map((o, index) => {
          const uniqueId = `${(currentPage - 1) * pageSize + index}-${o.operatore}-${o.prezzo}`;
          const priceNumber = parsePriceNumber(o.prezzo);
          const isIncomplete =
            !o.nomeOfferta || !o.dettagliAggiuntivi || priceNumber == null;
          
          return (
            <div
              key={uniqueId}
              className="offer-card"
            >
              <div className="logo-wrapper">
                <div className="logo-centered">
                  <img src={o.logo} alt={o.operatore} />
                </div>
              </div>

              <div>
                {!isIncomplete ? (
                  <>
                    <div className="offer-details">
                      <div className="offer-info">
                        <div>
                          <p className="text-info-price">{t.startingFrom}</p>
                          <p className="price">€{priceNumber.toFixed(2)}</p>
                          <p className="iva">{t.vatIncluded}</p>
                        </div>
                        <div className="description-wrapper">
                          <p className="offer-name adaptive-offer-name">{o.nomeOfferta}</p>
                          <button
                            className="toggle-details-btn"
                            onClick={() => handleToggleDescription(index, o.operatore, currentPage, uniqueId, o.segmentoClientela, o.prezzo)}
                            >
                
                      			{expandedCardId === uniqueId ? (
                        			<div className="expanded">
                          				<p>{t.lessDetails}</p>
                        			</div>
                     			) : (
                        		<div className="collapsed">
                          			<p>{t.details}</p>
                          	</div>
                      		)}
                    		  </button>
                        </div>
                      </div>
                    
                    </div>
                    { o.validita && (
                      <p className="validity">
                        {t.validUntil}{new Date(o.validita).toLocaleDateString("it-IT")}
                      </p>
                    )}
                    <p className={`description ${expandedCardId === uniqueId ? "expanded-description" : ""}`}>
                      {o.dettagliAggiuntivi}
                    </p>
                  </>
                ) : (
          		    <div className="offer-box-text-default">
                    <p className="default-offer-text">
                      {t.defaultOfferText}
                    </p>
                  </div>
          	    )}
             
                <button className="button" onClick={() => handleOpenLink(o, index)}>
                  {t.discoverOffer}
                </button>
              
              </div>
            </div>
          );
        })}
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <div className="pagination-controls">
            {currentPage > 1 && (
              <button onClick={() => handlePagination(currentPage - 1)}>
                {t.previous}
              </button>
            )}

            {Array.from({ length: totalPages }).map((_, i) => {
              const page = i + 1;
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <button
                    key={page}
                    onClick={() => handlePagination(page)}
                    className={page === currentPage ? "active" : ""}
                  >
                    {page}
                  </button>
                );
              }

              if (
                (page === currentPage - 2 && page > 2) ||
                (page === currentPage + 2 && page < totalPages - 1)
              ) {
                return <span key={`dots-${page}`}>...</span>;
              }

              return null;
            })}

            {currentPage < totalPages && (
              <button onClick={() => handlePagination(currentPage + 1)}>
                {t.next}
              </button>
            )}
          </div>
        </div>
      )}

      {showDisclaimer && (
        <div className="offers-disclaimer">
          <p>{t.offersDisclaimer}</p>
        </div>
      )}
    </div>
  );
}

